var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',_vm._g(_vm._b({attrs:{"no-fade":true,"id":_vm.id,"title":_vm.title,"hide-footer":true},on:{"hide":_vm.close}},'b-modal',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }